import { LOGIN_URL } from "@api/constants";
import { FC } from "react";

import CustomerPanel from "@components/CustomerPanel";
import FaIcon from "@components/FaIcon";
import { IconColor, IconType } from "@components/FaIcon/FaIcon";
import { UserConsumer } from "@components/UserContext";

const SecondaryNavigation: FC = () => {
  return (
    <>
      <UserConsumer>
        {(consumer) => (
          <ul className="SecondaryNavigation">
            {consumer?.customer ? (
              <li>
                {consumer?.customer.guest ? (
                  <a href={LOGIN_URL}>Sign in / Create</a>
                ) : (
                  <CustomerPanel customer={consumer?.customer} />
                )}
              </li>
            ) : null}
          </ul>
        )}
      </UserConsumer>
      {/* language=CSS */}
      <style jsx>
        {`
          .SecondaryNavigation {
            display: inline-block;
            margin: 0 0 20px 0;
            list-style-type: none;
            height: 18px;
          }

          .SecondaryNavigation li {
            display: inline-block;
          }

          a {
            color: rgb(168, 182, 190);
            text-decoration: none;
            font-size: 12px;
          }

          a:hover {
            color: rgb(236, 31, 0);
          }
        `}
      </style>
    </>
  );
};

export default SecondaryNavigation;
